import React, { useEffect, useLayoutEffect, useState, useCallback, useRef } from 'react';
import { Badge, Col, Icon, Row, Spin } from "antd";
import Auxiliary from "../../util/Auxiliary";

import {
    fetchResource as getAssetDetails,
    getAssetDeviceLastData,
    // getAssetDeviceBackupLastData, // No longer used: the backend getLastDeviceData() now falls back to the daily fuel data last packet itself
    getAssetDeviceRangeData,
    getAssetDeviceLastFuelData,
    getAssetDeviceDailyFuelData,
    processDeviceDailyFuelDataInPeriod
} from "../../appRedux/actions/Asset";
import { getLastReadingTimeBased as fetchLastManualAssetMeterReading } from '../../appRedux/actions/ManualAssetReading'
import { connect } from "react-redux";
import DeviceInfoData from "./DeviceInfoData"
import DeviceMap from "./Map";
import Widget from "../../components/Widget";
import moment from "moment/moment";
import FuelReportInfo from './fuel-report/FuelReportInfo';
import FuelReportDetails from './fuel-report/FuelConsumption';
import FuelConsumptionDetails from './fuel-report/FuelConsumption';
import FuelConsumptionRate from './fuel-report/FuelConsuptionRate';
import DeviceIdelMovingTime from './fuel-report/DeviceIdealMovingTime';
import DeviceMovement from './fuel-report/DeviceMovement';
import { groupFuelDataByGroupingName } from './fuel-report/fuelDataGroup';
import DeviceRefuelDrainChart from './fuel-report/DeviceRefuelDrainChart';
import FuelConsumptionHours from './fuel-report/FuelConsumtionHours'
import { Link } from 'react-router-dom';
import ShareTrackingUrl from './ShareTrackingUrl';
import axios from 'util/Api';
import SafetyEventCount from './fuel-report/SafetyEventCount';
import PeriodSelector from './fuel-report/PeriodSelector';

const ENABLE_LIVE_TOWING_POLL = false;

const mapStateToProps = ({ commonData, auth, asset, manualAssetReading }) => {
    return {
        // will be available as props.trips
        loading: commonData.loading,
        authUser: auth.authUser,
        asset: asset.edit,
        assetDeviceLastData: asset.assetDeviceLastData,
        assetDeviceFuelData: asset.assetDeviceFuelData,
        assetDeviceRangeData: asset.assetDeviceRangeData,
        assetDeviceRangeProcessedData: asset.assetDeviceRangeProcessedData,
        deviceFuelLoading: asset.deviceFuelLoading,
        assetDeviceDailyFuelData: asset.assetDeviceDailyFuelData,
        deviceDailyFuelDataLoading: asset.deviceDailyFuelDataLoading,
        lastManualReading: manualAssetReading.lastReadingWithTime,
        assetDeviceDailyFuelDataSuccess: asset.assetDeviceDailyFuelDataSuccess
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAssetDetails,
        getAssetDeviceLastData,
        // getAssetDeviceBackupLastData, // No longer used: the backend getLastDeviceData() now falls back to the daily fuel data last packet itself
        getAssetDeviceRangeData,
        getAssetDeviceLastFuelData,
        getAssetDeviceDailyFuelData,
        fetchLastManualAssetMeterReading,
        processDeviceDailyFuelDataInPeriod
    }
}

function DeviceDetails(props) {
    // Parse ?from=<ms>&to=<ms> from URL — frontend-only, no backend changes
    const urlSearchParams = new URLSearchParams(props.location && props.location.search)
    const urlFrom = urlSearchParams.get('from') ? Number(urlSearchParams.get('from')) : null
    const urlTo = urlSearchParams.get('to') ? Number(urlSearchParams.get('to')) : null
    const urlTowing = urlSearchParams.get('towing') === 'true'
    const urlAutoTriggeredRef = useRef(false)

    const [device, setDevice] = useState(null)
    const [deviceData, setDeviceData] = useState(null)
    const [deviceFuelData, setDeviceFuelData] = useState(null)
    const [assetId, setAssetId] = useState(null);
    const [assetData, setAssetData] = useState(null);
    const [deviceAssetData, setDeviceAssetData] = useState(null);
    const [hasFuelSensorAttached, setHasFuelSensorAttached] = useState(false);
    const [attachedFuelSensor, setAttachedFuelSensor] = useState(null);

    const [deviceDataRange, setDeviceDataRange] = useState([])
    const [showRangeData, setShowRangeData] = useState(false)
    const [fleetHistoryLoading, setFleetHistoryLoading] = useState(false)

    const [towingData, setTowingData] = useState(null)
    const [bleAssetsMap, setBleAssetsMap] = useState({})
    const [isSSEActive, setIsSSEActive] = useState(false)
    const [liveTowingData, setLiveTowingData] = useState(null)
    const liveTowingIntervalRef = useRef(null)
    const [eventSourceState, setEventSourceState] = useState(null)

    const [orgModules, setOrgModules] = useState([])

    const [mapSpeed, setMapSpeed] = useState(1)
    const [mapMaximized, setMapMaximized] = useState(false)
    const [mapHeight, setMapHeight] = useState('85vh')
    const [infoPanelExpanded, setInfoPanelExpanded] = useState(false)
    const deviceInfoRef = useRef(null)

    useEffect(() => {
        setMapHeight(mapMaximized ? 'calc(100vh - 64px)' : '85vh');
        if (!mapMaximized) setInfoPanelExpanded(false);
    }, [mapMaximized]);

    const [fuelData, setFuelData] = useState([]);

    // const orgModules = authUser && authUser.organisation && authuser.organisation.assetProModules || [];

    const [api, setApi] = useState(process.env.REACT_APP_ENVIRONMENT === `development`
        ? `http://localhost:3002/v2/`
        : process.env.REACT_APP_ENVIRONMENT === `production`
            ? `https://api.theassetpro.com/v2/`
            : `https://api.quonitrix.com/v2/`,)


    const removePolylines = () => {
        // console.log('rm 1')
        setShowRangeData(false);
    }

    useEffect(() => {
        const id = props.match.params.id;
        const aid = props.match.params.asset;
        // console.log(id, aid);
        // console.log(props.modules)
        if (id)
            setDevice(id)
        if (aid) {
            setAssetId(aid)
        }
        setDeviceData(null);
    }, []);

    // Auto-load fleet history when URL has ?from=&to= and device+assetId are ready
    useEffect(() => {
        if (!urlFrom || !urlTo || !assetId || !device) return
        if (urlAutoTriggeredRef.current) return
        urlAutoTriggeredRef.current = true
        handleFleetHistory([urlFrom, urlTo], urlTowing)
    }, [assetId, device, urlFrom, urlTo, urlTowing])

    useEffect(() => {
        if (props.authUser) {
            setOrgModules(props.authUser && props.authUser.organisation && props.authUser.organisation.assetProModules || [])
        }
    }, [props.authUser]);

    useEffect(() => {
        if (assetId)
            props.getAssetDetails(assetId)
    }, [assetId]);

    // useEffect(() => {
    //     console.log(props.deviceDailyFuelDataLoading);
    // }, [props.deviceDailyFuelDataLoading]);

    useEffect(() => {
        if (props.asset) {
            // console.log(device)
            const deviceAsset = props.asset.dependents && props.asset.dependents.length && props.asset.dependents.filter(dp => dp && dp.tagDeviceId && dp.tagDeviceId === device)
            // console.log(deviceAsset)
            if (deviceAsset && deviceAsset[0]) {
                setDeviceAssetData(deviceAsset[0])
                setAssetData(props.asset)
                // console.log(props.asset)
                const fuelSensors = deviceAsset[0].dependents && deviceAsset[0].dependents.length && deviceAsset[0].dependents.filter(dps =>
                    dps && dps.assetModel && dps.assetModel.isFuelSensorDevice)
                if (fuelSensors && fuelSensors[0]) {
                    setHasFuelSensorAttached(true)
                    setAttachedFuelSensor(fuelSensors)
                }
            }
        }
    }, [props.asset]);

    useEffect(() => {
        // console.log(assetId, device)
        if (assetId && device) {
            loadLastDeviceData(assetId, device);
            // Last fuel record API (device_fuel_records) is kept but no longer called
            // props.getAssetDeviceLastFuelData(assetId, device);
        }
    }, [assetId && device]);

    const loadLastDeviceData = async (aid, dev) => {
        await props.getAssetDeviceLastData(aid, dev);

        // No longer used: the separate backup call below is replaced by the backend.
        // GET /iot-device-data/:device/:asset (getLastDeviceData) now returns the last packet from
        // daily fuel data itself when the live table has no record (marked _source: 'daily_backup',
        // which still shows the "Last known" tag). Kept for reference.
        //
        // const lastData = await props.getAssetDeviceLastData(aid, dev);
        // // undefined = request failed; only fall back when the call succeeded with no record
        // const noRecord = lastData === null || lastData === '' ||
        //     (lastData !== undefined && typeof lastData === 'object' && !Object.keys(lastData).length);
        // if (noRecord) {
        //     props.getAssetDeviceBackupLastData(aid, dev);
        // }
    };

    useEffect(() => {
        // console.log(props.assetDeviceLastData)
        const data = props.assetDeviceLastData && props.assetDeviceLastData[device];
        // console.log('data - ', data)
        if (data)
            setDeviceData(data);
    }, [props.assetDeviceLastData]);

    useEffect(() => {
        const data = props.assetDeviceFuelData && props.assetDeviceFuelData[device];
        // console.log('data fuel - ', data)
        if (data)
            setDeviceFuelData(data);
    }, [props.assetDeviceFuelData]);

    useEffect(() => {

        let eventSource;
        const startSSE = () => {
            if (device && assetData && isSSEActive) {
                // console.log('starting sse')
                // console.log('assetData =>', assetData)
                eventSource = new EventSource(`${api}common/sse-device-status?device=${device}&asset=${assetData._id}`);
                setEventSourceState(eventSource)
                eventSource.onmessage = (event) => {
                    const data = JSON.parse(event.data);
                    if (data) {
                        console.log('data =>', data)
                        // setDeviceData({...data, ...{timestamp: data.timestamp + Math.random() * (999 - 100) + 100}});
                        setDeviceData(data);
                    }
                };

                eventSource.onerror = (error) => {
                    console.error('SSE error:', error);
                    eventSource.close();
                };
            }
        };

        if (isSSEActive) {
            startSSE();
        }

        return () => {
            // console.log('close -- ', eventSource)
            if (eventSource) {
                eventSource.close();
            }
        };
    }, [device, assetData, isSSEActive]);

    useEffect(() => {
        return () => {
            // console.log('close -- ', eventSource)
            if (eventSourceState) {
                eventSourceState.close();
            }
        };
    }, []);

    // Poll live towing data while SSE is active
    useEffect(() => {
        if (!ENABLE_LIVE_TOWING_POLL || !isSSEActive || !device) {
            setLiveTowingData(null)
            if (liveTowingIntervalRef.current) clearInterval(liveTowingIntervalRef.current)
            return
        }

        const fetchLiveTowing = () => {
            axios.get(`towing-events/live?deviceId=${device}`)
                .then(res => { if (res && res.data) setLiveTowingData(res.data) })
                .catch(() => { })
        }

        fetchLiveTowing()
        liveTowingIntervalRef.current = setInterval(fetchLiveTowing, 30000)

        return () => { if (liveTowingIntervalRef.current) clearInterval(liveTowingIntervalRef.current) }
    }, [isSSEActive, device])

    const handleSSESwitchChange = (checked) => {
        setIsSSEActive(checked);
        if (checked)
            setShowRangeData(false)
        else
            setShowRangeData(true)
    };

    const handleFleetHistory = async (dateRange, withTowing = false) => {
        if (dateRange && dateRange.length === 2) {
            setShowRangeData(false)
            setTowingData(null)
            setFleetHistoryLoading(true)
            try {
                // Await fleet history so the server-side GPS cache is warm before beacon-data
                // calls getDeviceDataWithinPeriodWithProcessing (needed for isGpsBasedDistance).
                await props.getAssetDeviceRangeData(assetId, device, dateRange[0], dateRange[1]);
            } finally {
                setFleetHistoryLoading(false)
            }
            setIsSSEActive(false);

            if (withTowing) {
                axios.get(`iot-device/beacon-data?imei=${device}&from=${dateRange[0]}&to=${dateRange[1]}`)
                    .then(async res => {
                        if (!res || !res.data) return
                        setTowingData(res.data)
                        // Build MAC → asset map for tooltip display (scan records + tow events)
                        const scanMacs = (res.data.data || []).map(r => r.instanceId || r.instanceid || r.instancsid || r.mac || '')
                        const towMacs = (res.data.towEvents || []).map(r => r.instanceId || '')
                        const uniqueMacs = [...new Set([...scanMacs, ...towMacs].filter(Boolean))]
                        const results = await Promise.all(uniqueMacs.map(mac =>
                            axios.get(`iot-device/ble-tag-asset?bleTagId=${encodeURIComponent(mac)}`).catch(() => null)
                        ))
                        const map = {}
                        uniqueMacs.forEach((mac, i) => { if (results[i] && results[i].data) map[mac] = results[i].data })
                        setBleAssetsMap(map)
                    })
                    .catch(err => console.warn('Towing data fetch failed:', err));
            }
        }
    }

    const handleFuelRefreshBtn = () => {
        // Last fuel record API is kept but no longer called
        // props.getAssetDeviceLastFuelData(assetId, device);
    }

    useEffect(() => {
        if (props.assetDeviceRangeData) {
            // console.log('props.assetDeviceRangeData=>', props.assetDeviceRangeData);
            const ranges = { ...props.assetDeviceRangeData };
            // console.log('ranges =>', ranges);
            if (ranges && ranges.data && ranges.data.length) {
                ranges.data.sort((a, b) => a.timestamp - b.timestamp);
                setDeviceDataRange(ranges)
            } else if (ranges && ranges.data && ranges.data.length === 0) {
                setDeviceDataRange([])
            }
        }
    }, [props && props.assetDeviceRangeData]);

    const callDailyProcessedFuelData = useCallback((from, to) => {
        if (from && to && device && assetId && props.getAssetDeviceDailyFuelData) {
            props.getAssetDeviceDailyFuelData(assetId, device, from, to, hasFuelSensorAttached)
        }
    }, [device, assetId, props.getAssetDeviceDailyFuelData, hasFuelSensorAttached])

    const [selectedValue, setSetselectedValue] = useState('7d');
    const [selectedGroup, setSelectedGroup] = useState('d');
    const [groupingLoading, setGroupingLoading] = useState(false);
    const autoFuelFetchKeyRef = useRef(null);

    const handlePeriodChange = (period) => {
        // console.log(period);
        setSetselectedValue(period)
    }
    const handleDataGroup = (group) => {
        // console.log(group);
        setSelectedGroup(group)
    }

    useEffect(() => {
        if (!device || !assetId || !assetData) return

        const fetchKey = `${assetId}-${device}-${hasFuelSensorAttached ? 1 : 0}`
        if (autoFuelFetchKeyRef.current === fetchKey) return

        const now = moment().subtract(1, 'days')
        const defaultTo = now.clone().endOf('day').valueOf()
        const defaultFrom = now.clone().subtract(6, 'days').startOf('day').valueOf()

        callDailyProcessedFuelData(defaultFrom, defaultTo)
        autoFuelFetchKeyRef.current = fetchKey
    }, [device, assetId, assetData, hasFuelSensorAttached, callDailyProcessedFuelData])

    useEffect(() => {
        // console.log(selectedGroup);
        if (selectedGroup === 'd' && props.assetDeviceDailyFuelData && props.assetDeviceDailyFuelData.data)
            setFuelData((props.assetDeviceDailyFuelData.data || []).map(doc => {
                return {
                    ...doc,
                    date: doc.date_timestamp ? moment(doc.date_timestamp).format('DD-MM') : moment(doc.date).format('DD-MM')
                }
            }))
        // setFuelData(props.assetDeviceDailyFuelData && props.assetDeviceDailyFuelData.data || []);
        else {
            setGroupingLoading(true);
            groupFuelDataByGroupingName(props.assetDeviceDailyFuelData && props.assetDeviceDailyFuelData.data || [], selectedGroup)
                .then(docs => {
                    setFuelData(docs)
                    setGroupingLoading(false)
                })
                .catch(err => setGroupingLoading(false))
        }
        // console.log(selectedGroup, props.assetDeviceDailyFuelData);
    }, [selectedGroup, props.assetDeviceDailyFuelData]);

    const processFuelData = useCallback((deviceId, from, to) => {
        props.processDeviceDailyFuelDataInPeriod(deviceId, from, to, assetId)
    }, [assetId, props.processDeviceDailyFuelDataInPeriod])

    return (
        <Auxiliary>
            <Spin spinning={props.loading}>
                {orgModules && orgModules.includes('Telematics') &&
                    <>
                        {/*
                          Single stable row — DeviceInfoData is ALWAYS the same
                          instance so internal state (fleet history dates etc.) survives
                          toggling maximized mode.
                          When maximized the right Col switches to position:absolute so
                          it overlays the map without being removed from the DOM.
                        */}
                        <Row type="flex" align="top" style={{ position: 'relative' }}>

                            {/* Left: cards (hidden when maximized) + map */}
                            <Col
                                sm={24} xs={24}
                                style={mapMaximized
                                    ? { flex: '0 0 100%', maxWidth: '100%' }
                                    : { flex: '0 0 66.666667%', maxWidth: '66.666667%' }}
                            >
                                {/* Asset + Location cards — hidden in maximized mode */}
                                {!mapMaximized && (
                                    <Row>
                                        <Col sm={24} xs={24} lg={12}>
                                            <Widget styleName="gx-card-full gx-dot-arrow-hover">
                                                <div className="gx-media gx-align-items-center gx-flex-nowrap" style={{ position: 'relative' }}>
                                                    <div className="gx-px-3 gx-build-box-lay">
                                                        <img alt="..." src={require('assets/images/widget/fixed-asset.png')} className="" />
                                                    </div>
                                                    <div className="gx-media-body gx-py-3 gx-pr-4 gx-build-box-lay-content">
                                                        <h2 className="h4 gx-text-truncate gx-mb-1">
                                                            {assetData && (<Link to={`/asset/history-report/${assetData._id}`}>
                                                                {assetData.assetCode || '-'} ({assetData.altName || '-'}) {assetData.ownerCode || '-'}
                                                            </Link>)}
                                                        </h2>
                                                        <p className="gx-mb-1 gx-text-black gx-fs-sm gx-mt-1">{assetData && assetData.assetModel && assetData.assetModel.name || '-'}</p>
                                                        <p className="gx-mb-0 gx-text-grey gx-fs-xs gx-mt-1">
                                                            {deviceAssetData && deviceAssetData.assetCode || '-'} ({deviceAssetData && deviceAssetData.tagDeviceId || '-'})
                                                            &nbsp;
                                                            {attachedFuelSensor && attachedFuelSensor.length && attachedFuelSensor.map(sensor => {
                                                                const calList = sensor && sensor.fuelSensorCalibrationList;
                                                                const filedName = calList && calList.fuelLevelIdentifierName;
                                                                return sensor.assetCode && sensor.assetCode + (filedName ? '(' + filedName + ')' : '')
                                                            }).join(', ') || '-'}
                                                        </p>
                                                    </div>
                                                    <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                                                        <ShareTrackingUrl assetId={assetId} device={device} />
                                                    </div>
                                                </div>
                                            </Widget>
                                        </Col>
                                        <Col sm={24} xs={24} lg={12}>
                                            <Widget styleName="gx-card-full gx-dot-arrow-hover">
                                                <div className="gx-media gx-align-items-center gx-flex-nowrap">
                                                    <div className="gx-px-3 gx-build-box-lay">
                                                        <img alt="..." src={require('assets/images/widget/location.png')} className="" />
                                                    </div>
                                                    <div className="gx-media-body gx-py-3 gx-pr-4 gx-build-box-lay-content">
                                                        <h2 className="h4 gx-text-truncate gx-mb-1">{assetData && assetData.location && assetData.location.name || '-'}</h2>
                                                        <p className="gx-mb-1 gx-text-black gx-fs-md gx-mt-1">&nbsp;</p>
                                                        <p className="gx-mb-0 gx-text-grey gx-fs-md gx-mt-1">{assetData && assetData.client && assetData.client.name || '-'}</p>
                                                    </div>
                                                </div>
                                            </Widget>
                                        </Col>
                                    </Row>
                                )}

                                {/* Map */}
                                <div className={`gx-card${mapMaximized ? ' device-map-card-maximized' : ''}`} style={{ marginBottom: 0 }}>
                                    <div className="gx-card-body" style={{ height: mapHeight, padding: 0, position: 'relative' }}>
                                        {/* Floating asset badge — maximized only */}
                                        {mapMaximized && (
                                            <div className="device-map-float-info">
                                                <div className="device-map-float-asset">
                                                    <strong>
                                                        {assetData && (<Link to={`/asset/history-report/${assetData._id}`} style={{ color: 'inherit' }}>
                                                            {assetData.assetCode || '-'} ({assetData.altName || '-'})
                                                        </Link>)}
                                                    </strong>
                                                    <span className="device-map-float-sub">{assetData && assetData.assetModel && assetData.assetModel.name || ''}</span>
                                                    <span className="device-map-float-sub">{assetData && assetData.location && assetData.location.name || ''}</span>
                                                </div>
                                            </div>
                                        )}
                                        <DeviceMap
                                            deviceData={deviceData} asset={assetData}
                                            rangeData={deviceDataRange} showRangeData={!isSSEActive}
                                            mapSpeed={mapSpeed} IsSSEActive={isSSEActive}
                                            isMaximized={mapMaximized}
                                            onToggleMaximize={() => setMapMaximized((v) => !v)}
                                            towingData={towingData}
                                            bleAssetsMap={bleAssetsMap}
                                        />

                                        {/* ── Maximized overlays: collapsed strip + floating panel ── */}
                                        {mapMaximized && (
                                            <>
                                                {/* Collapsed header strip */}
                                                {!infoPanelExpanded && (
                                                    <div className="device-info-collapsed-strip">
                                                        <button
                                                            className="device-info-collapsed-expand"
                                                            onClick={() => setInfoPanelExpanded(true)}
                                                            title="Expand device info"
                                                        >
                                                            <Icon type="left" />
                                                        </button>
                                                        <button className="device-info-collapsed-tab-label" onClick={() => setInfoPanelExpanded(true)}>
                                                            Device Status
                                                        </button>
                                                        <button className="device-info-collapsed-tab-label" onClick={() => setInfoPanelExpanded(true)}>
                                                            Fleet History
                                                        </button>
                                                    </div>
                                                )}

                                                {/* Floating expanded panel — inside card body so position:absolute is correct */}
                                                <div
                                                    className="device-info-glass"
                                                    style={{
                                                        position: 'absolute',
                                                        right: 0,
                                                        top: 0,
                                                        width: infoPanelExpanded ? 350 : 0,
                                                        height: '100%',
                                                        zIndex: 1000,
                                                        overflow: 'hidden',
                                                        transition: 'width 0.25s ease',
                                                        background: 'rgba(255,255,255,0.88)',
                                                        backdropFilter: 'blur(14px)',
                                                        WebkitBackdropFilter: 'blur(14px)',
                                                        borderLeft: '1px solid rgba(200,200,200,0.6)',
                                                        boxShadow: '-2px 0 24px rgba(0,0,0,0.18)',
                                                    }}
                                                >
                                                    <button
                                                        className="device-info-collapse-btn"
                                                        onClick={() => setInfoPanelExpanded(false)}
                                                        title="Collapse panel"
                                                    >
                                                        <Icon type="right" />
                                                    </button>
                                                    <div style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>
                                                        <DeviceInfoData
                                                            deviceData={deviceData} deviceFuelData={deviceFuelData}
                                                            deviceFuelLoading={props.deviceFuelLoading} isSSEActive={isSSEActive}
                                                            handleFuelRefreshBtn={handleFuelRefreshBtn}
                                                            handleSSESwitchChange={handleSSESwitchChange} assetData={assetData}
                                                            handleFleetHistory={handleFleetHistory} loading={fleetHistoryLoading}
                                                            removePolylines={removePolylines} setMapSpeed={setMapSpeed}
                                                            rangeData={deviceDataRange}
                                                            fetchLastManualAssetMeterReading={props.fetchLastManualAssetMeterReading}
                                                            lastManualReading={props.lastManualReading}
                                                            towingData={towingData}
                                                            liveTowingData={liveTowingData}
                                                            urlFrom={urlFrom}
                                                            urlTo={urlTo}
                                                            urlTowing={urlTowing}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </Col>

                            {/* DeviceInfoData in normal (non-maximized) mode */}
                            {!mapMaximized && (
                                <Col
                                    sm={24} xs={24}
                                    style={{
                                        flex: '0 0 33.333333%',
                                        maxWidth: '33.333333%',
                                        alignSelf: 'flex-start',
                                    }}
                                >
                                    <div ref={deviceInfoRef}>
                                        <DeviceInfoData
                                            deviceData={deviceData} deviceFuelData={deviceFuelData}
                                            deviceFuelLoading={props.deviceFuelLoading} isSSEActive={isSSEActive}
                                            handleFuelRefreshBtn={handleFuelRefreshBtn}
                                            handleSSESwitchChange={handleSSESwitchChange} assetData={assetData}
                                            handleFleetHistory={handleFleetHistory} loading={fleetHistoryLoading}
                                            removePolylines={removePolylines} setMapSpeed={setMapSpeed}
                                            rangeData={deviceDataRange}
                                            fetchLastManualAssetMeterReading={props.fetchLastManualAssetMeterReading}
                                            lastManualReading={props.lastManualReading}
                                            towingData={towingData}
                                            liveTowingData={liveTowingData}
                                            bleAssetsMap={bleAssetsMap}
                                            urlFrom={urlFrom}
                                            urlTo={urlTo}
                                            urlTowing={urlTowing}
                                        />
                                    </div>
                                </Col>
                            )}
                        </Row>

                        {/* Period selector bar — sits between the map and the fuel charts */}
                        <Row style={{ marginTop: 16 }}>
                            <Col span={24}>
                                <div className="period-selector-bar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '6px 12px', borderRadius: 6, marginBottom: 8 }}>
                                    <PeriodSelector
                                        handleDataGroup={handleDataGroup}
                                        selectedGroup={selectedGroup}
                                        handlePeriodChange={handlePeriodChange}
                                        selectedValue={selectedValue}
                                        callFuelData={callDailyProcessedFuelData}
                                        device={device}
                                        loading={props.deviceDailyFuelDataLoading || groupingLoading}
                                        hasFuelSensor={hasFuelSensorAttached}
                                        assetDeviceDailyFuelDataSuccess={props.assetDeviceDailyFuelDataSuccess}
                                        processDeviceDailyFuelDataInPeriod={processFuelData}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12} sm={24} xs={24} lg={12}>
                                <FuelConsumptionDetails kay='fuel' handlePeriodChange={handlePeriodChange} selectedValue={selectedValue}
                                    handleDataGroup={handleDataGroup} selectedGroup={selectedGroup} hasFuelSensor={hasFuelSensorAttached}
                                    callFuelData={callDailyProcessedFuelData} device={device} assetData={assetData} data={fuelData}
                                    loading={props.deviceDailyFuelDataLoading || groupingLoading} />
                            </Col>
                            <Col span={12} sm={24} xs={24} lg={12}>
                                <FuelConsumptionRate key='rate' handlePeriodChange={handlePeriodChange} selectedValue={selectedValue}
                                    handleDataGroup={handleDataGroup} selectedGroup={selectedGroup} hasFuelSensor={hasFuelSensorAttached}
                                    callFuelData={callDailyProcessedFuelData} device={device} assetData={assetData}
                                    data={fuelData} loading={props.deviceDailyFuelDataLoading || groupingLoading}
                                    assetDeviceDailyFuelDataSuccess={props.assetDeviceDailyFuelDataSuccess}
                                    processDeviceDailyFuelDataInPeriod={processFuelData} />
                            </Col>

                        </Row>

                        <Row>
                            <Col span={12} sm={24} xs={24} lg={12}>
                                <DeviceIdelMovingTime key='idle' handleDataGroup={handleDataGroup} selectedGroup={selectedGroup}
                                    hasFuelSensor={hasFuelSensorAttached}
                                    handlePeriodChange={handlePeriodChange} selectedValue={selectedValue} callFuelData={callDailyProcessedFuelData}
                                    device={device} assetData={assetData} data={fuelData} loading={props.deviceDailyFuelDataLoading || groupingLoading} />
                            </Col>
                            <Col span={12} sm={24} xs={24} lg={12}>
                                <DeviceMovement key='kms' handlePeriodChange={handlePeriodChange} selectedValue={selectedValue}
                                    handleDataGroup={handleDataGroup} selectedGroup={selectedGroup} hasFuelSensor={hasFuelSensorAttached}
                                    callFuelData={callDailyProcessedFuelData} device={device} assetData={assetData}
                                    data={fuelData}
                                    rawData={props.assetDeviceDailyFuelData && props.assetDeviceDailyFuelData.data || []}
                                    loading={props.deviceDailyFuelDataLoading || groupingLoading} />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} sm={24} xs={24} lg={24}>
                                <FuelConsumptionHours key='hours-rate' handleDataGroup={handleDataGroup} selectedGroup={selectedGroup}
                                    hasFuelSensor={hasFuelSensorAttached}
                                    handlePeriodChange={handlePeriodChange} selectedValue={selectedValue} callFuelData={callDailyProcessedFuelData}
                                    device={device} assetData={assetData} data={fuelData} loading={props.deviceDailyFuelDataLoading || groupingLoading} />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} sm={24} xs={24} lg={24}>
                                <SafetyEventCount
                                    key='safety-event-count'
                                    selectedGroup={selectedGroup}
                                    data={props.assetDeviceDailyFuelData && props.assetDeviceDailyFuelData.data || []}
                                    loading={props.deviceDailyFuelDataLoading || groupingLoading}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} sm={24} xs={24} lg={24}>
                                <DeviceRefuelDrainChart key='refuel-drain' handleDataGroup={handleDataGroup} selectedGroup={selectedGroup}
                                    hasFuelSensor={hasFuelSensorAttached}
                                    handlePeriodChange={handlePeriodChange} selectedValue={selectedValue} callFuelData={callDailyProcessedFuelData}
                                    device={device} assetData={assetData} data={fuelData} loading={props.deviceDailyFuelDataLoading || groupingLoading} />
                            </Col>
                        </Row>
                    </>

                }
            </Spin>
        </Auxiliary >
    );
}

export default connect(mapStateToProps, mapDispatchToProps())(DeviceDetails);
